var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/EllipseLoader.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EllipseLoader = ({
  color = 'rgba(76, 94, 207, 1)',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "42",
  height: "42",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0",
    to: "360",
    repeatCount: "indefinite"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 37.0732C12.123 37.0732 4.92683 29.877 4.92683 21C4.92683 12.123 12.123 4.92683 21 4.92683C29.877 4.92683 37.0732 12.123 37.0732 21H42C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42V37.0732Z",
    fill: color
  })]
});